

<h6 class="comment-title"><i class="fas fa-user-circle"></i> {{comment.user.name}} </h6>
<div class="row ms-3">
    {{comment.comments.comment}}
</div>
<div class="date-created ms-3">
    {{comment.created_at }}
</div>
